import { Link } from "react-router";

/** Shared RetrieveIT.AI wordmark - matches retrieveit.ai marketing. */
export function Wordmark({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const retrieveClass =
    size === "lg"
      ? "text-2xl sm:text-3xl"
      : size === "sm"
        ? "text-base"
        : "text-xl sm:text-2xl";
  const itClass =
    size === "lg"
      ? "text-3xl sm:text-4xl"
      : size === "sm"
        ? "text-lg"
        : "text-2xl sm:text-3xl";
  return (
    <Link to="/" className={`wordmark ${retrieveClass}`} aria-label="RetrieveIT.AI status home">
      Retrieve
      <span className={`wordmark-it ${itClass}`}>IT</span>
      <span className="wordmark-tld">.AI</span>
      <span className="ml-2 text-sm font-medium text-gray-500 uppercase tracking-wider">
        Status
      </span>
    </Link>
  );
}
